import React, { useLayoutEffect, useMemo } from 'react';

import { Fuse, printMissingConfigError, SiteConfigManager } from '@atlas/core';

import { loadScript } from 'common/utils';

const ApgLicense = ({ iconSize, iconStyle }) => {
  const anjouanId = SiteConfigManager.getConfig('config.config.license.anjouanId');
  const anjouanDomID = SiteConfigManager.getConfig('config.config.license.anjouanDomID', 'X41');

  if (!anjouanId) {
    printMissingConfigError('config.config.license.anjouanId');
  }

  useLayoutEffect(() => {
    const anjouanWindowObject = window[anjouanDomID.replaceAll('-', '_')];

    if (
      anjouanWindowObject &&
      typeof anjouanWindowObject === 'object' &&
      typeof anjouanWindowObject.init === 'function'
    ) {
      try {
        anjouanWindowObject.init();
      } catch (e) {
        console.error("Can't show anjouan license");
      }
    } else {
      (async () => {
        await loadScript(`https://${anjouanId}.snippet.anjouangaming.org/anj-seal.js`);
      })();
    }
  }, []);

  return useMemo(() => {
    const anjouanLicenseDomElement = document.querySelector(`#${anjouanDomID}`);

    if (!anjouanLicenseDomElement) {
      return (
        <div
          className="e-gaming-logo"
          data-anj-image-size={iconSize}
          data-anj-image-type="basic-small"
          data-anj-seal-id={anjouanId}
          id={anjouanDomID}
          style={iconStyle}
        />
      );
    }

    return (
      <div
        className="e-gaming-logo"
        dangerouslySetInnerHTML={{ __html: anjouanLicenseDomElement.innerHTML }}
      />
    );
  }, []);
};

const fallback = () => <div />;

export default function (props) {
  return (
    <Fuse fallback={fallback}>
      <ApgLicense {...props} />
    </Fuse>
  );
}
